import { z } from "zod";

export const LabelSchema = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  color: z.string(),
});
